import React, { useState, useRef } from 'react'
import { post } from '../utils/apiClient'
import { Link, useNavigate } from 'react-router-dom'
import { useAccount, useUser } from '../entities'
import PasswordResetModal from '../components/Modals/PasswordResetModal'
import { Button, Form, Input, Grid, Segment } from 'semantic-ui-react'
import { FormMessage } from 'choice-forms'

export default function Signin() {
  const [accountData] = useAccount()
  let refUsername = useRef()
  let refUserPassword = useRef()
  const navigate = useNavigate()
  const [, { updateUser }] = useUser()
  const [state, setState] = useState({
    form_message: '',
    is_reset_password: false,
    is_loading: false,
    is_logo: true
  })

  const onSubmitForm = async () => {
    if (state.is_loading) {
      return false
    }
    setState({ ...state, form_message: '', is_loading: true })
    let res = await post('/api/user/login', {
      data: {
        username: refUsername.current.value,
        password: refUserPassword.current.value
      }
    })
    if (res.person) {
      res.user = res.person
    }
    if (res.ok && res.user) {
      updateUser(res.user)
      if (res.user.admin_access) {
        if (
          window.location.pathname === '/signin' ||
          window.location.pathname === '/account' ||
          window.location.pathname === '/'
        ) {
          navigate(`/dashboard`)
        }
      } else if (window.location.pathname === '/signin') {
        navigate(`/`)
      }
    } else {
      setState({ ...state, form_message: res, is_loading: false })
    }
  }

  const closeResetModal = async ({ close_modal }) => {
    if (close_modal) {
      setState({ ...state, is_reset_password: false })
    }
  }
  const { accountSettings } = accountData

  return (
    <div className="signin-form" style={{ background: '#fff' }}>
      <Grid textAlign="center" style={{ height: '100vh' }}>
        <Grid.Column
          style={{ maxWidth: 450, marginTop: '3rem' }}
          className="mr-4 ml-4">
          {state.is_logo ? (
            <div style={{ maxWidth: 300, margin: '0 auto' }}>
              <img
                src="/assets/logo.png"
                onError={() => setState({ ...state, is_logo: false })}
                alt={
                  accountData.accountSettings
                    ? accountData.accountSettings.account_name
                    : 'Admin'
                }
                className="app-logo"
                style={{ width: '100%' }}
              />
            </div>
          ) : (
            <div
              style={{
                maxWidth: 300,
                margin: '0 auto',
                fontSize: '35px',
                fontWeight: 'bold',
                lineHeight: '1em'
              }}>
              {accountSettings ? accountSettings.account_name : 'Admin'}
            </div>
          )}
          {/* <Header as="h2" textAlign="center" style={{ color: '#1472A4' }}>
            {' '}
            Sign in to your account
          </Header> */}
          <Form size="large" className="mt-4">
            <Segment stacked>
              <Form.Field>
                <Input
                  name="username"
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="Email address"
                  autoFocus="autoFocus"
                  ref={refUsername}
                />
              </Form.Field>
              <Form.Field>
                <Input
                  name="password"
                  type="password"
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Password"
                  ref={refUserPassword}
                />
              </Form.Field>
              {state.form_message && <FormMessage {...state.form_message} />}
              <Button
                content="Sign in"
                onClick={() => onSubmitForm()}
                fluid
                size="large"
                loading={state.is_loading}
                style={{
                  backgroundColor: '#1472A4',
                  color: 'white',
                  borderRadius: 0
                }}
              />
            </Segment>
          </Form>

          <Segment basic textAlign="right" size="small" className="pt-0 pb-0">
            <div
              className="alink"
              onClick={() =>
                setState({
                  ...state,
                  is_reset_password: true,
                  form_message: ''
                })
              }>
              Forgot your password?
            </div>
          </Segment>
          {accountSettings.isAllowRegister ? (
            <div className="mt-5 mb-4" style={{ textAlign: 'left' }}>
              {`Don't have an account?`}
              <Link to="/register" className="ml-2" tabIndex="5">
                Create account
              </Link>
            </div>
          ) : (
            ''
          )}
        </Grid.Column>
      </Grid>
      {state.is_reset_password && (
        <PasswordResetModal modalAction={closeResetModal} />
      )}
    </div>
  )
}
